// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__26DdM","label":"Labeled_label__1XxGS","divider":"Labeled_divider__2ijVL"};